import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useTenantAdminAuth } from '../../auth/TenantAdminAuthContext.jsx';
import { AuthLayout } from '../../components/layout/AuthLayout.jsx';
import { PasswordField } from '../../components/forms/PasswordField.jsx';
import { Icon } from '../../components/Icon.jsx';

export function LoginPage() {
  const { login } = useTenantAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname ?? '/', { replace: true });
    } catch (err) {
      setError(err.message || 'Could not log in.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title="Welcome back." description="Your menus, your team. All in one place." role="Restaurant admin" footer={<Link to="/login/passkey">Sign in with a passkey <Icon name="arrow" size={14} /></Link>}>
      {error && <div className="alert alert-error" role="alert">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" required autoComplete="username" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <PasswordField id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <p className="auth-forgot"><Link to="/forgot-password">Forgot your password?</Link></p>
        <button type="submit" className="btn btn-primary auth-submit" disabled={submitting}>
          {submitting ? 'Signing in…' : <>Sign in <Icon name="arrow" size={17} /></>}
        </button>
      </form>
    </AuthLayout>
  );
}
